import React from 'react';
import Heading from './components/Heading/Heading';
import VideosControlPanel from './components/VideosControlPanel/VideosControlPanel';
import Videos from './components/Videos/Videos';
import PaginationComponent from './components/PaginationComponent/PaginationComponent';
import style from './VideosSection.module.scss';

const VideosSection: React.FC = () => {
	return (
		<div className={style.container} data-test="VideosSection">
			<div className={style.wrapper}>
				<Heading />
				<VideosControlPanel />
				<Videos />
				<PaginationComponent />
			</div>
		</div>
	);
};

export default VideosSection;
